export const iconFontAwesomeConstructionPaintRoller = (
	<i className="fa-solid fa-paint-roller"></i>
);
